import { app } from '../../../../../../app';

app.component('companyDirectoryIntegrationManageInstructionsScim', {
    bindings: {
    },
    templateUrl: require('./directory-integration-instructions-scim.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/scim/instructions/directory-integration-instructions-scim.component.js